import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { Roles, Role } from './types.tsx';

export const getRoleEndpointUrl = (projectId: string): string =>
	`/rest/api/2/project/${encodeURIComponent(projectId)}`;

export const getRolesForProjectIdEndpointUrl = (
	projectId: string,
	isCurrentMember: boolean,
): string =>
	`${getRoleEndpointUrl(projectId)}/roledetails${isCurrentMember ? '?currentMember=true' : ''}`;

export const getRoleForProjectIdAndRoleIdEndpointUrl = (
	projectId: string,
	roleId: string,
): string => `${getRoleEndpointUrl(projectId)}/role/${encodeURIComponent(roleId)}`;

export const getRoles = (projectId: string, isCurrentMember: boolean): Promise<Roles> =>
	fetchJson(getRolesForProjectIdEndpointUrl(projectId, isCurrentMember));

export const getRole = (projectId: string, roleId: string): Promise<Role> =>
	fetchJson(getRoleForProjectIdAndRoleIdEndpointUrl(projectId, roleId));
